import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from "@services/constantsService";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SettingsName } from "./class/SettingsName";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private readonly constantsService: ConstantsService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.get('No-Auth') === 'True') {
            return next.handle(req.clone());
        }

        if (req.url.indexOf("/api/") === 0 || req.url.indexOf("/commserver/") === 0) {

            req = this.addAPIUrlPrefix(req);
        }

        if (this.getAccessToken()) {
            const clonedreq = this.addBearerToken(req);

            return next.handle(clonedreq).pipe(
                tap(
                    succ => { },
                    err => {
                        if (err.status === 401) {
                            // this.router.navigateByUrl('/login');
                        } else if ((err.status = 403)) {
                            // this.router.navigateByUrl('/forbidden');
                            // alert(err.localStorage.getItem('userToken'));
                        }
                    }
                )
            );
        }
        else {
            //this.router.navigateByUrl('/login');
        }

        return next.handle(req);
    }

    // ---

    private addAPIUrlPrefix(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({ url: `${this.constantsService.getApiUrl()}${request.url}` });
    }

    private addBearerToken(request: HttpRequest<any>): HttpRequest<any> {
        const bearer = this.getAccessToken();

        return request.clone({
            headers: request.headers.set('Authorization', `Bearer ${bearer}`)
        });
    }

    private getAccessToken(): string {
        return window.sessionStorage.getItem(SettingsName.AccessToken.toString());
    }
}
